export default __webpack_public_path__ + "static/media/cube.8d6b0c25.svg";